import React, { Component } from "react";
import { CheckUser, Usernotification, RemoveNoti } from "../../Model/Users";
import { withRouter, VirsionCheck } from "../../Helpers/Common"; //Include Home
import { motion } from "framer-motion";
import { SVGIcons, ImgIcons } from "../../Helpers/Common";
import { Mobilemenu } from "../Mobile_menu/Mobilemenu";
import { Link } from 'react-router-dom';
import BarLoader from "react-spinners/BarLoader";

var SVGIcon = "";
var ImageData = "";
ImgIcons().then((result) => (ImageData = result));
SVGIcons().then((resultData) => (SVGIcon = resultData));

class Notifcation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      VirsionCheckData: false,
      VirsionCheckDataloaded: false,
      NotifcationData: false,
      Notaction: false,
      SelectedNot: false,
      isLive: true,
    };
  }

  componentDidMount() {
    document.title = "DocuBay";
    //Get Get User checked Check Data
    VirsionCheck().then((vcheckres) => {
      this.setState({
        isLive: JSON.parse(vcheckres.data).data.is_live_tv,
      });
    });
    CheckUser().then((checkuserstatus) => {
      if (checkuserstatus == null) {
        this.props.navigate("/createaccount");
      } else {

        Usernotification().then((usernotification) => {
          this.setState({

            VirsionCheckDataloaded: true,
            NotifcationData: usernotification,
          });
        });

      }
    });
  }

  formatAMPM = (date) => {
    var ss = new Date(date).toDateString();
    return ss;
  };

  NotActionpopup(index) {
    var Allnotification = this.state.NotifcationData.data.notifications[index];

    this.setState({
      Notaction: true,
      SelectedNot: Allnotification,
      indexSel: index
    });
  }

  closemodel() {
    this.setState({
      Notaction: false,
      SelectedNot: false
    });
  }

  removenoti(id, index) {

    var postData = {
      notification_id: id,
      status: "Inactive"
    }

    RemoveNoti(postData).then((resp) => {

      var Resp = JSON.parse(resp.data);

      if (Resp.success == true) {

        var Statedata = this.state.NotifcationData.data.notifications;
        var myda = Statedata.splice(this.state.indexSel, 1);

        this.closemodel()

      } else {
        this.closemodel()
      }

    })
  }

  render() {
    if (this.state.VirsionCheckDataloaded == false) {
      // return <div className="loader"></div>;
      return <div className="loader"><BarLoader color="#ff000f" /></div>;
    } else {

      if (this.state.NotifcationData.data.errorcode == 1152) {
        return (
          <>
            <div className="notification-box">
              <div className="notification-head">
                <div className="docubayBack white pl-8 mt-0">
                  <img
                    src={SVGIcon['back.svg']}
                    alt="DocuBay"
                    onClick={() => {
                      this.props.functions.NotificationClose();
                    }}
                    className="notification-close"
                  />
                  Notifications
                </div>
              </div>

              <section className="mb-0">
                <div className="notification-message"><p>{this.state.NotifcationData.data.message.split('\n')[0]} <span>{this.state.NotifcationData.data.message.split('\n')[1]}</span></p></div>
              </section>
              <Mobilemenu active="1" isLive={this.state.isLive} />
            </div>
          </>
        );
      } else {
        return (
          <>
            {/* notifications popup start */}
            <div className="dD-none">
              <div className="notification-box">
                <div className="notification-head">
                  <div className="docubayBack white pl-8 mt-0">
                    <img
                      src={SVGIcon['back.svg']}
                      alt="DocuBay"
                      onClick={() => {
                        this.props.functions.NotificationClose();
                      }}
                      className="notification-close"
                    />
                    Notifications
                  </div>
                </div>
                <section className="mb-0">
                  {this.state.NotifcationData.data.notifications.map(
                    (NotiData, index) => {
                      if (NotiData.notification_type === "Manage Membership") {
                        var link = "/manage-membership";
                      } else if (NotiData.notification_type === "Manage Profile") {
                        var link = "/profile";
                      } else if (NotiData.notification_type === "Plan Detail") {
                        var link = "/become-a-member";
                      } else {
                        var link = "/profile";
                      }
                      return (
                        <div className="notification-inn" key={index}>
                          <div className="rdot" />
                          <div className="tdot bannerpop-modal-toggle">
                            <img src={ImageData['Delete-Icon-1.png']} style={{ width: "38%" }} alt="DocuBay" onClick={() => {
                              this.NotActionpopup(index);
                            }} />
                          </div>
                          <Link to={link}>
                            <div className="noti-left-content">
                              <img src={NotiData.image} alt="DocuBay" style={{ width: "150px" }} />
                              <div className="notification-right">
                                <h5 style={{ fontSize: "12px" }}>{NotiData.notification_type}</h5>
                                <h6 style={{ fontSize: "10px" }}>{NotiData.description}</h6>
                                <h6>{this.formatAMPM(NotiData.modified_on)}</h6>
                              </div>
                            </div>
                          </Link>
                        </div>
                      );
                    }
                  )}
                </section>
                <Mobilemenu active="1" isLive={this.state.isLive} />
              </div>
              {this.state.Notaction ? (
                <div className="bannerpop" id="bPop" style={{
                  display: this.state.Notaction
                    ? "flex"
                    : "none",
                }}>
                  <div className="bannerpop-modal-body">
                    <button className="bannerpop-modal-close bannerpop-modal-toggle" onClick={() => {
                      this.closemodel()
                    }}>
                      <img src={SVGIcon['promocode-close.svg']} alt="DocuBay" />
                    </button>
                    <div className="bannerpop-awesome">
                      <h5>{this.state.SelectedNot.notification_type}</h5>
                      <h6 onClick={() => { this.removenoti(this.state.SelectedNot.ID) }}>
                        <img src={SVGIcon['remove-list.svg']} /> Remove from List
                      </h6>
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
          </>
        );
      }
    }
  }
}

export default withRouter(Notifcation);
